import gql from 'graphql-tag'

export const QUESTIONS = gql`
  query Questions(
    $surveyId: Int!
    $dimensionId: Int
    $topicId: Int
    $subtopicId: Int
    $groupId: Int
    $sectorId: Int
    $limit: Int
    $offset: Int
  ) {
    filteredQuestions(
      surveyId: $surveyId
      dimensionId: $dimensionId
      topicId: $topicId
      subtopicId: $subtopicId
      groupId: $groupId
      sectorId: $sectorId
      limit: $limit
      offset: $offset
    ) {
      id
      hierarchy
      statement
      questionType
      protocols
      references
      documents
      comments {
        userId
        isPrivate: restrict
        status
      }
      tags {
        abbreviation
        name
        type
      }
      choices {
        id
        rowText
        colText
        tags {
          id
          type
        }
      }
    }
  }
`

export const REFERENCE = gql`
  query Questions(
    $surveyId: Int!
    $dimensionId: Int
    $topicId: Int
    $subtopicId: Int
    $groupId: Int
    $sectorId: Int
    $limit: Int
    $offset: Int
  ) {
    filteredQuestions(
      surveyId: $surveyId
      dimensionId: $dimensionId
      topicId: $topicId
      subtopicId: $subtopicId
      groupId: $groupId
      sectorId: $sectorId
      limit: $limit
      offset: $offset
    ) {
      id
      hierarchy
      statement
      questionType
      comments {
        userId
        isPrivate: restrict
        status
      }
      tags {
        abbreviation
        name
        type
      }
      choices {
        id
        rowText
        colText
        tags {
          id
          type
        }
      }
    }
  }
`
